"use strict";


($dt => {
	
	const controller = {
		
		/**
		 * This is called for each block matching this type
		 * @param {HTMLElement} container 
		 */
		LoadBlock: container => {
			const [ ticket_elems, tickets ] = [ 
				container.querySelectorAll('.ticket-item') ,
				{
					button_elem: container.querySelector('.button-add-cart'),
					base_url: '',
					items: [],
					get_url: () => {
						let url = tickets.base_url;
						let index = 1;
						tickets.items.forEach(t => {
							const quantity = t.get_quantity();
							if (quantity > 0) {
								url += '&PLU' + index + '=' + t.plu + '&QTY' + index + '=' + quantity;
								index++;
							}
						});
						return url;
					},
					get_total_quantity: () => {
						let quantity = 0;
						tickets.items.forEach(t => {
							quantity += t.get_quantity();
						});
						return quantity;
					}
				}
			];

			if (tickets.button_elem) {
				tickets.base_url = tickets.button_elem.getAttribute('data-base-url');
				ticket_elems.forEach(elem => {
					const ticket = {
						wrapper: elem,
						plu: elem.getAttribute('data-ticket-plu'),
						price: parseFloat(elem.getAttribute('data-ticket-price')),
						get_quantity: () => {
							const amount_elem = ticket.wrapper.querySelector('.amount');
							let amount = 0;
							if (amount_elem) {
								amount = parseInt(amount_elem.innerHTML);
								if (isNaN(amount)) {
									amount = 0;
								}
							}
							return amount;
						}
					};

					if (ticket.plu && ticket.price && ticket.price >= 0) {
						tickets.items.push(ticket);

						const [ incrementer_elems, quantity_elem ] = [
							elem.querySelectorAll('.increment'),
							elem.querySelector('.amount')
						];

						incrementer_elems.forEach(inc_elem => {
							inc_elem.addEventListener('click', () => {
								const quantity = ticket.get_quantity();
								let has_update = false;
								if (inc_elem.getAttribute('data-increment') === 'minus') {
									if (quantity > 0) {
										quantity_elem.innerHTML = quantity - 1;
										has_update = true;
									}
								} else {
									quantity_elem.innerHTML = quantity + 1;
									has_update = true;
								}

								if (has_update) {
									controller.RefreshTickets(tickets);
								}
							});
						});
					}
				});

				tickets.button_elem.addEventListener('click', () => {
					if (tickets.get_total_quantity() > 0) {
						window.open(tickets.get_url(), '_blank');
						//console.log(tickets.get_url());
					}
				});
			}
		},

		RefreshTickets: tickets => {
			const { button_elem } = tickets;
			if (button_elem) {
				if (tickets.get_total_quantity() > 0) {
					// Get URL and enable button
					button_elem.removeAttribute('disabled');
				} else {
					// Disable button
					button_elem.setAttribute('disabled', 'disabled');
				}
			}
		}
		
	};

	$dt.blocks['ticket-list'] = controller;
	
})(window.d3_wp_themejs);
